module.exports = __webpack_public_path__ + "img/icon-39.f6876da0.png";